import { contemTextoPesquisa } from "../Utils/pesquisaTexto";
import React, { useEffect, useState, useMemo } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  CircularProgress,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import { db, auth } from "../Config/firebase";
import {
  addDoc,
  collection,
  Timestamp,
  getDocs,
  getCountFromServer,
  query,
  orderBy,
  doc,
  updateDoc,
  where,
  limit,
  startAfter,
} from "firebase/firestore";

import Navbar from "../Components/Navbar/navbar";
import HistoricoCadastro from "../Components/HistoricoCadastro/HistoricoCadastro";
import PaginationComponent from "../Components/PaginationComponents/paginationcomponents";
import PaginationSelector from "../Components/PaginationSelector/paginationselector";
import TutorialCadastro from "../Components/TutorialCadastro/TutorialCadastro";
import { ETAPAS_TUTORIAL_CLIENTES } from "../Components/TutorialCadastro/etapasTutoriais";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useHistory } from "react-router-dom";
import { aplicarTenant, getUsuarioAtualComTenant, tenantWhere , consultaTenantAtual, aplicarTenantAtual} from "../Utils/tenant";
import { podeEditarCadastroDireto } from "../Utils/aprovacaoCadastro";
import {
  atualizarDocumentoComMesclagem,
  extrairCamposAlterados,
} from "../Utils/concorrenciaFirestore";
import "./CadastroClientes.css";

const ITENS_POR_PAGINA_CLIENTES = 20;
const SUGESTAO_HISTORICO_NECESSIDADES_TECNICAS =
  "Necessidades técnicas a confirmar: escopo dos serviços, normas técnicas aplicáveis, requisitos de segurança e treinamentos dos colaboradores envolvidos.";
const SUGESTAO_REQUISITOS_CLIENTE =
  "Cumprimento das normas técnicas e de segurança vigentes aplicáveis; atendimento aos requisitos legais e contratuais; realização dos treinamentos necessários aos colaboradores envolvidos.";

function dataCadastroISO(valor) {
  if (!valor) return "";
  if (typeof valor === "string" && /^\d{4}-\d{2}-\d{2}$/.test(valor)) return valor;
  const data = valor.toDate ? valor.toDate() : new Date(valor);
  if (Number.isNaN(data.getTime())) return "";
  return `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, "0")}-${String(data.getDate()).padStart(2, "0")}`;
}

export default function CadastroClientes({ open, isMobile }) {
  /* =========================
     STATES
  ========================= */
  const [nome, setNome] = useState("");
  const [dataCadastro, setDataCadastro] = useState("");
  const [documento, setDocumento] = useState("");
  const [contato, setContato] = useState("");
  const [telefone, setTelefone] = useState("");
  const [tipoCliente, setTipoCliente] = useState("");
  const [historicoNecessidadesTecnicas, setHistoricoNecessidadesTecnicas] = useState("");
  const [requisitosCliente, setRequisitosCliente] = useState("");
  const [clientes, setClientes] = useState([]);
  const [totalClientes, setTotalClientes] = useState(null);
  const [clientesBusca, setClientesBusca] = useState(null);
  const [loading, setLoading] = useState(false);
  const [carregandoLista, setCarregandoLista] = useState(true);
  const [clienteEditando, setClienteEditando] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [pesquisa, setPesquisa] = useState("");
  const [filtroStatus, setFiltroStatus] = useState("ativos");
  const [userName, setUserName] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itensPerPage, setItensPerPage] = useState(ITENS_POR_PAGINA_CLIENTES);
  const [lastDocs, setLastDocs] = useState([]);
  const [pages, setPages] = useState(1);
  const [usuarioAtual, setUsuarioAtual] = useState(null);
  const [openTutorial, setOpenTutorial] = useState(false);
  const [openProximaEtapa, setOpenProximaEtapa] = useState(false);
  const history = useHistory();

  /* =========================
     USUÁRIO LOGADO
  ========================= */
  useEffect(() => {
    async function carregarUsuario() {
      if (!auth.currentUser) return;
      const usuario = await getUsuarioAtualComTenant();
      setUsuarioAtual(usuario);
      setUserName(usuario.nome);
    }

    carregarUsuario();
  }, []);

  /* =========================
     CARREGAR CLIENTES
  ========================= */
  async function carregarClientes(page = currentPage) {
    if (pesquisa.trim()) {
      await carregarClientesParaBusca();
      return;
    }
    setCarregandoLista(true);
    setTotalClientes(null);

    try {
      const constraints = [];
      constraints.push(...tenantWhere(usuarioAtual));

      if (filtroStatus === "ativos") constraints.push(where("ativo", "==", true));
      if (filtroStatus === "inativos") constraints.push(where("ativo", "==", false));

      constraints.push(orderBy("nome"));

      const consultaContagem = consultaTenantAtual(query(collection(db, "clientes"), ...constraints));

      if (page > 0 && lastDocs[page - 1]) {
        constraints.push(startAfter(lastDocs[page - 1]));
      }

      constraints.push(limit(itensPerPage + 1));

      const [snapshot, contagem] = await Promise.all([
        getDocs(consultaTenantAtual(query(collection(db, "clientes"), ...constraints))),
        getCountFromServer(consultaContagem).catch((err) => {
          console.error("Erro ao contar clientes:", err);
          return null;
        }),
      ]);
      setTotalClientes(contagem?.data().count ?? null);
      const docsPagina = snapshot.docs.slice(0, itensPerPage);
      const temProximaPagina = snapshot.docs.length > itensPerPage;

      const lista = docsPagina.map((d) => ({
        id: d.id,
        ...d.data(),
      }));

      setClientes(lista);
      setLastDocs((prev) => {
        const updated = [...prev];
        if (docsPagina.length) updated[page] = docsPagina[docsPagina.length - 1];
        return updated;
      });
      setPages(temProximaPagina ? page + 2 : page + 1);
    } catch (err) {
      console.error("Erro ao carregar clientes:", err);
    } finally {
      setCarregandoLista(false);
    }
  }

  useEffect(() => {
    if (pesquisa.trim()) return;
    if (usuarioAtual) carregarClientes(currentPage);
  }, [currentPage, itensPerPage, filtroStatus, pesquisa, usuarioAtual]);

  useEffect(() => {
    setCurrentPage(0);
    setLastDocs([]);
    setPages(1);
  }, [itensPerPage, filtroStatus]);

  async function carregarClientesParaBusca() {
    setCarregandoLista(true);

    try {
      const constraints = [];
      constraints.push(...tenantWhere(usuarioAtual));

      if (filtroStatus === "ativos") constraints.push(where("ativo", "==", true));
      if (filtroStatus === "inativos") constraints.push(where("ativo", "==", false));

      constraints.push(orderBy("nome"));

      const snapshot = await getDocs(consultaTenantAtual(query(collection(db, "clientes"), ...constraints)));

      setClientesBusca(snapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
    } catch (err) {
      console.error("Erro ao buscar clientes:", err);
      setClientesBusca([]);
    } finally {
      setCarregandoLista(false);
    }
  }

  useEffect(() => {
    setClientesBusca(null);
    setCurrentPage(0);
    setLastDocs([]);
    setPages(1);

    if (pesquisa.trim()) {
      if (usuarioAtual) carregarClientesParaBusca();
    }
  }, [pesquisa, filtroStatus, usuarioAtual]);

  /* =========================
     NOVO CLIENTE
  ========================= */
  function novoCliente() {
    setClienteEditando(null);
    setDataCadastro(dataCadastroISO(new Date()));
    setNome("");
    setDocumento("");
    setContato("");
    setTelefone("");
    setTipoCliente("");
    setHistoricoNecessidadesTecnicas(SUGESTAO_HISTORICO_NECESSIDADES_TECNICAS);
    setRequisitosCliente(SUGESTAO_REQUISITOS_CLIENTE);
    setOpenDialog(true);
  }

  useEffect(() => {
    if (new URLSearchParams(window.location.search).get("novo") === "1") {
      novoCliente();
    }
  }, []);

  /* =========================
     EDITAR CLIENTE
  ========================= */
  function editarCliente(cliente) {
    setClienteEditando(cliente);
    setDataCadastro(dataCadastroISO(cliente.dataCadastro || cliente.criadoEm));
    setNome(cliente.nome || "");
    setDocumento(cliente.documento || "");
    setContato(cliente.contato || "");
    setTelefone(cliente.telefone || "");
    setTipoCliente(cliente.tipoCliente || "");
    setHistoricoNecessidadesTecnicas(cliente.historicoNecessidadesTecnicas || "");
    setRequisitosCliente(cliente.requisitosCliente || "");
    setOpenDialog(true);
  }

  async function getUsuarioLogado() {
  return getUsuarioAtualComTenant();
}

  /* =========================
     SALVAR CLIENTE
  ========================= */
  async function salvarCliente() {
  if (!dataCadastro) {
    alert("Informe a data de cadastro.");
    return;
  }
  if (!nome.trim()) {
    alert("Informe o nome do cliente");
    return;
  }

  setLoading(true);

  try {
    const usuario = await getUsuarioLogado();

    if (!usuario.tenantId) {
      alert("Usuario sem tenantId. O superadmin deve criar/usar um admin de cliente SaaS para cadastros operacionais.");
      return;
    }

    const dados = aplicarTenant({
      dataCadastro,
      nome: nome.trim(),
      documento: documento.trim(),
      contato: contato.trim(),
      telefone: telefone.trim(),
      tipoCliente,
      historicoNecessidadesTecnicas: historicoNecessidadesTecnicas.trim(),
      requisitosCliente: requisitosCliente.trim(),
      ativo: clienteEditando ? clienteEditando.ativo : true,
    }, usuario);

    const criandoCliente = !clienteEditando;

    if (clienteEditando) {
      if (podeEditarCadastroDireto(usuario, clienteEditando)) {
        const atualizadoEm = Timestamp.now();
        await atualizarDocumentoComMesclagem({
          db,
          referencia: doc(db, "clientes", clienteEditando.id),
          original: clienteEditando,
          atual: { ...clienteEditando, ...dados },
          metadados: { atualizadoEm, atualizadoPor: usuario.uid },
        });
      } else if (usuario.tipo === "colaborador") {
        await addDoc(collection(db, "aprovacoes"), aplicarTenantAtual({
          tipo: "cliente",
          colecao: "clientes",
          registroId: clienteEditando.id,
          dadosAtuais: clienteEditando,
          dadosSolicitados: extrairCamposAlterados(clienteEditando, {
            ...clienteEditando,
            ...dados,
          }),
          status: "pendente",
          tenantId: usuario.tenantId,
          criadoEm: Timestamp.now(),
          criadoPor: usuario,
        }));

        alert("Alteração enviada para aprovação do administrador.");
      } else {
        alert("Usuário sem permissão para editar cliente.");
        return;
      }
    } else {
      if (usuario.tipo === "admin" || usuario.tipo === "colaborador") {
        await addDoc(collection(db, "clientes"), aplicarTenantAtual({
          ...dados,
          criadoEm: Timestamp.now(),
          criadoPor: usuario.uid,
          criadoPorNome: usuario.nome,
          criadoPorTipo: usuario.tipo,
        }));
      } else {
        alert("Usuário sem permissão para cadastrar cliente.");
        return;
      }
    }

    setOpenDialog(false);
    setNome("");
    setDocumento("");
    setContato("");
    setTelefone("");
    setTipoCliente("");
    setHistoricoNecessidadesTecnicas("");
    setRequisitosCliente("");
    setClienteEditando(null);
    setCurrentPage(0);
    setLastDocs([]);
    setPages(1);
    setClientesBusca(null);
    carregarClientes(0);

    if (
      criandoCliente &&
      new URLSearchParams(window.location.search).get("onboarding") === "1"
    ) {
      setOpenProximaEtapa(true);
    }
  } catch (err) {
    console.error("Erro ao salvar cliente:", err);
    alert("Erro ao salvar cliente");
  } finally {
    setLoading(false);
  }
}

  /* =========================
     ATIVAR / DESATIVAR
  ========================= */
 async function toggleAtivo(cliente) {
  try {
    const usuario = await getUsuarioLogado();

    const dados = {
      ativo: !cliente.ativo,
    };

    if (podeEditarCadastroDireto(usuario, cliente)) {
      await updateDoc(doc(db, "clientes", cliente.id), dados);
    } else if (usuario.tipo === "colaborador") {
      await addDoc(collection(db, "aprovacoes"), aplicarTenantAtual({
        tipo: "cliente",
        tenantId: usuario.tenantId,
        colecao: "clientes",
        registroId: cliente.id,
        dadosAtuais: cliente,
        dadosSolicitados: dados,
        status: "pendente",
        criadoEm: Timestamp.now(),
        criadoPor: usuario,
      }));

      alert("Alteração enviada para aprovação do administrador.");
    } else {
      alert("Usuário sem permissão.");
      return;
    }

    setClientesBusca(null);
    carregarClientes(currentPage);
  } catch (err) {
    console.error("Erro ao alterar status:", err);
    alert("Erro ao alterar status do cliente.");
  }
}

  /* =========================
     FILTRO + PESQUISA
  ========================= */
  const clientesFiltrados = useMemo(() => {
    const base = pesquisa.trim() ? (clientesBusca || []) : clientes;

    return base
      .filter((cliente) => {
        const termoPesquisa = pesquisa.toLocaleLowerCase("pt-BR");
        const nomeOk = [
          cliente.nome,
          cliente.documento,
          cliente.contato,
          cliente.telefone,
          cliente.tipoCliente,
          cliente.historicoNecessidadesTecnicas,
          cliente.requisitosCliente,
        ].some((valor) => contemTextoPesquisa(String(valor || "").toLocaleLowerCase("pt-BR"), termoPesquisa));

        const statusOk =
          filtroStatus === "todos" ||
          (filtroStatus === "ativos" && cliente.ativo) ||
          (filtroStatus === "inativos" && !cliente.ativo);

        return nomeOk && statusOk;
      })
      .sort((a, b) =>
        a.nome.localeCompare(b.nome, "pt-BR", { sensitivity: "base" })
      );
  }, [clientes, clientesBusca, pesquisa, filtroStatus]);

  /* =========================
     RENDER
  ========================= */
  return (
    <>
      <Navbar open={open} isMobile={isMobile} userName={userName} />

      <Box sx={{ p: 4, mt: 6 }}>
        <Paper className="cabecalho-lista-cadastro" elevation={0}>
        <Typography variant="h5" mb={3}>
          RQ 6.1 - Cadastro de Clientes
        </Typography>

        <Stack direction="row" spacing={2} mb={3} alignItems="center">
          <Button
            variant="contained"
            onClick={novoCliente}
            sx={{ height: 56 }}
          >
            + Cadastrar Cliente
          </Button>

          <Button
            variant="outlined"
            startIcon={<HelpOutlineIcon />}
            onClick={() => setOpenTutorial(true)}
            sx={{ height: 56, whiteSpace: "nowrap" }}
          >
            Ver tutorial
          </Button>

          <TextField
            label="Pesquisar cliente"
            value={pesquisa}
            onChange={(e) => setPesquisa(e.target.value)}
            sx={{ flex: 1 }}
          />

          <Typography variant="body2" sx={{ whiteSpace: "nowrap", fontWeight: 600 }} aria-live="polite">
            Quantidade de clientes: {carregandoLista || (pesquisa.trim() && clientesBusca === null)
              ? "..."
              : pesquisa.trim() ? clientesFiltrados.length : totalClientes ?? "—"}
          </Typography>

          <TextField
            select
            label="Status"
            value={filtroStatus}
            onChange={(e) => setFiltroStatus(e.target.value)}
            sx={{ width: 180 }}
          >
            <MenuItem value="todos">Todos</MenuItem>
            <MenuItem value="ativos">Ativos</MenuItem>
            <MenuItem value="inativos">Inativos</MenuItem>
          </TextField>
        </Stack>
        </Paper>

        <Paper sx={{ overflowX: "auto" }}>
          <Table className="lista-cadastro-padrao" sx={{ minWidth: 1450 }}>
            <TableHead>
              <TableRow>
                <TableCell>Nome</TableCell>
                <TableCell>CNPJ/CPF</TableCell>
                <TableCell>Contato</TableCell>
                <TableCell>Telefone</TableCell>
                <TableCell>Tipo de cliente</TableCell>
                <TableCell>Histórico e necessidades técnicas</TableCell>
                <TableCell>Requisitos do cliente</TableCell>
                <TableCell>Status</TableCell>
                <TableCell width={200}>Ações</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {carregandoLista && (
                <TableRow>
                  <TableCell colSpan={9}>Carregando...</TableCell>
                </TableRow>
              )}

              {!carregandoLista && clientesFiltrados.length === 0 && (
                <TableRow>
                  <TableCell colSpan={9}>
                    Nenhum cliente encontrado.
                  </TableCell>
                </TableRow>
              )}

              {clientesFiltrados.map((cliente) => (
                <TableRow key={cliente.id}>
                  <TableCell className="lista-dado-principal">{cliente.nome}</TableCell>
                  <TableCell className="lista-dado-secundario">{cliente.documento || "-"}</TableCell>
                  <TableCell>{cliente.contato || "-"}</TableCell>
                  <TableCell>{cliente.telefone || "-"}</TableCell>
                  <TableCell>{cliente.tipoCliente || "-"}</TableCell>
                  <TableCell sx={{ minWidth: 220, whiteSpace: "pre-wrap" }}>{cliente.historicoNecessidadesTecnicas || "-"}</TableCell>
                  <TableCell sx={{ minWidth: 260, whiteSpace: "pre-wrap" }}>{cliente.requisitosCliente || "-"}</TableCell>

                  <TableCell>
                    {cliente.ativo ? "Ativo" : "Inativo"}
                  </TableCell>

                  <TableCell>
                    <Stack direction="row" spacing={1}>
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => editarCliente(cliente)}
                      >
                        Editar
                      </Button>

                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => toggleAtivo(cliente)}
                      >
                        {cliente.ativo ? "Desativar" : "Ativar"}
                      </Button>
                      <HistoricoCadastro colecao="clientes" documentoId={cliente.id} registro={cliente} />
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>

        {!pesquisa.trim() && (
          <Stack direction="row" justifyContent="space-between" mt={2}>
            <PaginationSelector itensPerPage={itensPerPage} setItensPerPage={setItensPerPage} />
            <PaginationComponent pages={pages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
          </Stack>
        )}

        <Dialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>
            {clienteEditando ? "Editar Cliente" : "Novo Cliente"}
          </DialogTitle>

          <DialogContent dividers>
            <Stack spacing={2} mt={1}>
              <TextField label="Data de cadastro" type="date" value={dataCadastro} onChange={(e) => setDataCadastro(e.target.value)} InputLabelProps={{ shrink: true }} required fullWidth />
              <TextField
                label="Nome do Cliente"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                fullWidth
              />

              <TextField
                label="CNPJ/CPF"
                value={documento}
                onChange={(e) => setDocumento(e.target.value)}
                fullWidth
              />

              <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                <TextField
                  label="Contato"
                  value={contato}
                  onChange={(e) => setContato(e.target.value)}
                  fullWidth
                />

                <TextField
                  label="Telefone"
                  value={telefone}
                  onChange={(e) => setTelefone(e.target.value)}
                  fullWidth
                />
              </Stack>

              <TextField
                select
                label="Tipo de cliente"
                value={tipoCliente}
                onChange={(e) => setTipoCliente(e.target.value)}
                fullWidth
              >
                <MenuItem value="">Não informado</MenuItem>
                <MenuItem value="Construtora">Construtora</MenuItem>
                <MenuItem value="Concreteira">Concreteira</MenuItem>
                <MenuItem value="Autônomo">Autônomo</MenuItem>
                <MenuItem value="Cliente corporativo">Cliente corporativo</MenuItem>
                <MenuItem value="Cooperativa habitacional">Cooperativa habitacional</MenuItem>
                <MenuItem value="Outro">Outro</MenuItem>
              </TextField>

              <TextField
                label="Histórico e necessidades técnicas"
                value={historicoNecessidadesTecnicas}
                onChange={(e) => setHistoricoNecessidadesTecnicas(e.target.value)}
                multiline
                minRows={3}
                fullWidth
              />

              <TextField
                label="Requisitos do Cliente"
                helperText="Informe requisitos legais, contratuais e não especificados, como normas técnicas, treinamentos e normas de segurança."
                value={requisitosCliente}
                onChange={(e) => setRequisitosCliente(e.target.value)}
                multiline
                minRows={4}
                fullWidth
              />
            </Stack>
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpenDialog(false)}>
              Cancelar
            </Button>

            <Button
              variant="contained"
              onClick={salvarCliente}
              disabled={loading}
            >
              {loading
                ? <CircularProgress size={22} />
                : clienteEditando ? "Atualizar" : "Salvar"}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openProximaEtapa} maxWidth="sm" fullWidth>
          <DialogTitle>Muito bem! Só falta mais um passo.</DialogTitle>
          <DialogContent dividers>
            Agora cadastre uma obra vinculada ao cliente. Após esse cadastro, você poderá utilizar todo o sistema com a rastreabilidade correta dos ensaios.
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={() => history.push("/app/cadastroobras?novo=1&onboarding=1")}
            >
              Cadastrar obra
            </Button>
          </DialogActions>
        </Dialog>
        <TutorialCadastro
          open={openTutorial}
          onClose={() => setOpenTutorial(false)}
          titulo="Tutorial — Cadastro de Clientes"
          etapas={ETAPAS_TUTORIAL_CLIENTES}
        />
      </Box>
    </>
  );
}
